export default __webpack_public_path__ + "static/media/slider2.95de2963.jpg";